import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnInit,
} from '@angular/core';
import { SelectedGradeStateService } from '@app/infrastructure/core/services/state/selected-grade-state.service';
import { UserStateService } from '@app/infrastructure/core/services/state/user-state.service';
import { RoleEnum } from '@app/infrastructure/models/role';
import {
  IQuizBlockDTO,
  QuizBlockDTO,
  QuizTypes,
} from '@app/infrastructure/models/quiz-block';

@Component({
  selector: 'app-quiz-block-viewer',
  templateUrl: './quiz-block-viewer.component.html',
  styleUrls: ['./quiz-block-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class QuizBlockViewerComponent implements OnInit {
  @Input() quiz: IQuizBlockDTO = new QuizBlockDTO();
  @Input() gradeLevel: number;
  @Input() isTeacher: boolean = false;
  constructor(
    private gradeState: SelectedGradeStateService,
    private userStateService: UserStateService,
  ) {
    this.gradeLevel = this.gradeState.gradeId;
  }
  public QUIZTYPE = QuizTypes;

  public ordinal(str: string): string {
    return String.fromCharCode(parseInt(str, 10) + 65);
  }
  ngOnInit(): void {
    const user = this.userStateService.userSession;
    this.isTeacher = user?.role?.roleName === RoleEnum.TEACHER;
  }
}
